import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NewsItem } from '../models/news-item'
import { LocalisedDatePipe } from 'aih-launchpad-core';
import { NewsCategoryPipe } from '../news-category.pipe';
import { NgTemplateOutlet } from '@angular/common';
import { NewsImageAvatarComponent } from '../news-image-avatar/news-image-avatar.component';

@Component({
    selector: 'app-news-item',
    templateUrl: './news-item.component.html',
    styleUrls: ['./news-item.component.sass'],
    imports: [
      LocalisedDatePipe,
      NewsCategoryPipe,
      NgTemplateOutlet,
      NewsImageAvatarComponent
    ]
})
export class NewsItemComponent {

  @Input()item!: NewsItem;

  @Input() showTime: boolean = false;

  @Output()
  newsClicked: EventEmitter<string> = new EventEmitter<string>();

  clickNews(newsId: string): void {
    this.newsClicked.emit(newsId);
  }
}
